module.exports = __webpack_public_path__ + "img/bg-top-recruit-service.154007a3.png";